import { useEffect } from "react";
import useLenis from "@/lib/useLenis";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import Lineup from "@/components/Lineup";
import WhenWhere from "@/components/WhenWhere";

export default function Landing() {
  useLenis();

  useEffect(() => {
    document.title = "Sunburn Desert Mirage · Bengaluru, June 2022";
  }, []);

  return (
    <main data-testid="landing-root" className="relative text-[#FFF7ED]">
      <Header />
      <Hero />
      <Lineup />
      <WhenWhere />
    </main>
  );
}
